import { requireAdmin } from '@/plugins/router';
import UserCreatePage from '@/user/pages/UserCreatePage.vue';
import UserOverviewPage from '@/user/pages/UserOverviewPage.vue';
import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import UserActivatePage from './pages/UserActivatePage.vue';
import UserDeactivatePage from './pages/UserDeactivatePage.vue';
import UserDetailsPage from './pages/UserDetailsPage.vue';
import UserUpdatePage from './pages/UserUpdatePage.vue';

export const userRoutes = <RouteRecordRaw[]>[
    {
        path: '/users',
        children: [
            {
                path: '',
                name: 'users',
                component: UserOverviewPage,
            },
            {
                path: ':userId',
                name: 'user-details',
                props: true,
                component: UserDetailsPage,
            },
            {
                path: ':userId/edit',
                name: 'user-edit',
                props: true,
                beforeEnter: requireAdmin,
                component: UserUpdatePage,
            },
            {
                path: ':userId/deactivate',
                name: 'user-deactivate',
                props: true,
                beforeEnter: requireAdmin,
                component: UserDeactivatePage,
            },
            {
                beforeEnter: requireAdmin,
                path: 'user/create',
                name: 'user-create',
                component: UserCreatePage,
            },
            {
                path: 'user/activate',
                name: 'user-activate',
                beforeEnter: requireAdmin,
                component: UserActivatePage,
                props: (r: RouteLocationNormalized) => ({
                    oid: r.query.oid,
                    provider: r.query.provider,
                }),
            },
        ],
    },
];
